import React, { useState } from 'react'
import ListGroup from 'react-bootstrap/ListGroup'
import { useNavigate } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import Modal from '@mui/material/Modal'
import Card from '@mui/material/Card'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'

import {
  removeSelectedTransactions,
  removeSelectedAidrops,
} from 'src/contexts/airdropActionCreators'
import { txType } from 'src/pages/AirDrop/types'
import SectionTitle from 'src/components/kit/SectionTitle'
import { tokenSelectObjectType } from 'src/util/types'
import { formatAddressEllipsisShort } from 'src/util/formatAddressEllipsis'
import UiButton from 'src/ui/atoms/Button'
import './ConfirmRemoveModal.scss'

export default function ConfirmRemoveModal({
  showRemoveModal,
  toggleRemoveModal,
  transactionsData,
  selectedTransactions,
  updateAirdropTransactions,
  bulkId,
  selectedToken,
}: {
  showRemoveModal: boolean
  toggleRemoveModal: () => void
  transactionsData: txType[]
  selectedTransactions: any
  bulkId: any
  updateAirdropTransactions: (transactions: []) => void
  selectedToken: tokenSelectObjectType
}) {
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  const filteredTransactionsData = transactionsData?.filter(
    (tx) => selectedTransactions?.includes(tx?.id),
  )

  const removingAllTransactions = filteredTransactionsData?.length === transactionsData?.length

  const handleRemoveTransactions = async () => {
    try {
      setIsLoading(true)
      const res = await removeSelectedTransactions(selectedTransactions, bulkId)
      updateAirdropTransactions(res)
      setIsLoading(false)
      toggleRemoveModal()

      if (removingAllTransactions) {
        removeSelectedAidrops([bulkId])
        navigate('/airdrop')
      }
    } catch (error) {
      setIsLoading(false)
      console.error(error)
    }
  }

  return (
    <Modal
      open={showRemoveModal}
      onClose={toggleRemoveModal}
      aria-labelledby="confirm-modal"
      aria-describedby="confirm-remove-modal">
      <Card
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minHeight: '300px',
          maxHeight: '90%',
          width: '580px',
          maxWidth: '90%',
          background: '#181D38',
          color: '#fff',
          borderRadius: '16px',
        }}>
        <Box
          py={3}
          px={3}
          sx={{
            width: '100%',
            height: '100%',
            minHeight: '300px',
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '8px',
            boxSizing: 'border-box',
          }}>
          <SectionTitle title="Removing transactions to the following receivers:" />
          <div className="txListContainer">
            <PerfectScrollbar>
              <ListGroup as="ol" numbered>
                {filteredTransactionsData?.map((tx) => (
                  <ListGroup.Item as="li" key={tx?.id}>
                    <div>
                      <span className="transaction-summary-item">
                        {formatAddressEllipsisShort(tx?.receiver)}
                      </span>
                      <span className="dotted-line"></span>
                      <span className="transaction-amount transaction-summary-item">
                        {new Intl.NumberFormat().format(tx?.amount)} {selectedToken?.name}
                      </span>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </PerfectScrollbar>
          </div>
          {removingAllTransactions ? (
            <div className="removingAirdropInfoContainer">
              <span className="removingAirdropInfo">
                Removing all the transactions will result in removing the entire airdrop as well
              </span>
            </div>
          ) : null}
          <Box
            mt={4}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              width: '100%',
              gap: '40px',
            }}>
            <UiButton name="Cancel" size="M" onClick={toggleRemoveModal} type="secondary" />

            <Button
              className="btn btn-primary"
              color="error"
              size="medium"
              variant="contained"
              onClick={handleRemoveTransactions}
              disabled={isLoading}>
              Remove
              {isLoading ? (
                <CircularProgress color="warning" size="2rem" sx={{ marginLeft: '1rem' }} />
              ) : null}
            </Button>
          </Box>
        </Box>
      </Card>
    </Modal>
  )
}
